import React from 'react'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import OrderDetails from "../../components/Shop/OrderDetails";

const ShopOrderDetails = () => {
    return (
        <div className="min-h-screen bg-secondary-50">
            <DashboardSideBar active={2} />
            <div className="lg:ml-64 pt-16 lg:pt-0 min-h-screen">
                <div className="p-4 sm:p-6 lg:p-8">
                    <OrderDetails />
                </div>
            </div>
        </div>
    )
}

export default ShopOrderDetails

